var _style, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverbadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.8 77.4",
    style: {
      enableBackground: "new 0 0 79.8 77.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.0434,
    y1: 51.2904,
    x2: 79.6119,
    y2: 51.2904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751C1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#9F2426"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    style: {
      stopColor: "#C5282D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#DD2931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#EA2A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    style: {
      stopColor: "#DA2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#BB2529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    style: {
      stopColor: "#8D1E1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#871C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    style: {
      stopColor: "#411917"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#341313"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,53.9c0,0-0.9-7.2-15.2-9.6c-14.3-2.4,0,14.3,0,14.3L79.6,53.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.5269,
    y1: 51.2904,
    x2: 437.0956,
    y2: 51.2904,
    gradientTransform: "matrix(-1 0 0 1 437.5254 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#661617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3961,
    style: {
      stopColor: "#871C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4064,
    style: {
      stopColor: "#8D1E1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "#BB2529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    style: {
      stopColor: "#DA2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#EA2A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6575,
    style: {
      stopColor: "#DD2931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    style: {
      stopColor: "#C5282D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8762,
    style: {
      stopColor: "#9F2426"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#751C1B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.4,53.9c0,0,0.9-7.2,15.2-9.6c14.3-2.4,0,14.3,0,14.3L3.7,55.3L0.4,53.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.8721,
    y1: 38.25,
    x2: 77.3726,
    y2: 38.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01110156,
    style: {
      stopColor: "#5B5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09929644,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1398,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#EBEBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3602,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    style: {
      stopColor: "#5B5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5771,
    style: {
      stopColor: "#AAAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6129,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7366,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8387,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.9,62.8c-1.8,1.8-3.3,7.2-5.5,8.5c-2.2,1.3-7.7,0-10.1,0.6c-2.4,0.7-6.5,4.6-9,4.6c-2.5,0-6.6-3.9-9.1-4.5 c-2.4-0.6-7.9,0.7-10.1-0.5c-2.2-1.3-3.8-6.6-5.6-8.4c-1.8-1.8-7.2-3.3-8.5-5.5c-1.3-2.2,0-7.7-0.6-10.1c-0.7-2.4-4.6-6.5-4.6-9 c0-2.5,3.9-6.6,4.5-9.1C6,27,4.6,21.5,5.9,19.3c1.3-2.2,6.6-3.8,8.4-5.6c1.8-1.8,3.3-7.2,5.5-8.5c2.2-1.3,7.7,0,10.1-0.6 c2.4-0.7,6.5-4.6,9-4.6c2.5,0,6.6,3.9,9.1,4.5c2.4,0.6,7.9-0.7,10.1,0.5c2.2,1.3,3.8,6.6,5.6,8.4c1.8,1.8,7.2,3.3,8.5,5.5 c1.3,2.2,0,7.7,0.6,10.1c0.7,2.4,4.6,6.5,4.6,9c0,2.5-3.9,6.6-4.5,9.1c-0.6,2.4,0.7,7.9-0.5,10.1C71.1,59.4,65.7,61,63.9,62.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 38.2,
    cy: 38.2,
    r: 26.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.9512,
    y1: 42.6817,
    x2: 39.7721,
    y2: 34.3318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05658591,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1946,
    style: {
      stopColor: "#C1C1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7263,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 37.4,
    cy: 38.5,
    r: 4.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.4909,
    y1: 52.2906,
    x2: 47.5758,
    y2: 20.9666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05658591,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1946,
    style: {
      stopColor: "#C1C1C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2581,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7263,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8053,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.9,26.8c-1.6-4.1-8.1-6.5-12.5-3.3c-2.7-0.9-5.5-1.1-8.5-0.4c-4.3,1-7.6,3.3-9.9,7c-2.3,3.7-3,7.7-2.1,12 c1,4.3,3.3,7.6,7,9.9c3.7,2.3,7.7,3,12,2.1c4.3-1,7.6-3.3,9.9-7c2.3-3.7,3-7.7,2.1-12c-0.6-2.6-1.7-4.9-3.3-6.7 c1.4-1.1,3.2-1.5,5.1-1.2c0.1,0,0.2,0,0.3,0C54.9,27,54.9,26.9,54.9,26.8z M46.3,44.2c-1.5,2.4-3.7,4-6.5,4.6 c-2.8,0.6-5.5,0.2-7.9-1.4c-2.4-1.6-4-3.7-4.6-6.6c-0.6-2.8-0.2-5.5,1.3-7.9c1.6-2.5,3.7-4,6.6-4.6c2.8-0.6,5.5-0.2,7.9,1.4 c2.5,1.6,4,3.7,4.6,6.6C48.3,39.2,47.8,41.8,46.3,44.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4298,
    y1: 61.523,
    x2: 79.6119,
    y2: 61.523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751C1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#9F2426"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    style: {
      stopColor: "#C5282D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2961,
    style: {
      stopColor: "#DD2931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    style: {
      stopColor: "#EA2A33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    style: {
      stopColor: "#DA2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#BB2529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    style: {
      stopColor: "#8D1E1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    style: {
      stopColor: "#871C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E42930"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79.6,69.2c-26.4-11-52.8,11-79.2,0c0-5.1,0-10.2,0-15.3c26.4,11,52.8-11,79.2,0C79.6,59,79.6,64.1,79.6,69.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4,65.6c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.3-0.3-0.6-0.5c-0.6-0.3-1.1-0.7-1.4-1C8,63.4,7.9,63,8,62.5 c0.1-0.5,0.3-0.8,0.8-1c0.4-0.2,0.9-0.3,1.5-0.2c0.6,0.1,1.1,0.3,1.4,0.7c0.3,0.4,0.4,0.8,0.3,1.3l0,0l-1.2-0.2 c0-0.3,0-0.5-0.1-0.6c-0.1-0.1-0.3-0.2-0.6-0.3c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.2,0.2-0.3,0.4c0,0.2,0,0.3,0.1,0.4 c0.1,0.1,0.4,0.3,0.7,0.5c0.6,0.3,1,0.6,1.3,0.9c0.3,0.3,0.4,0.7,0.3,1.2c-0.1,0.5-0.3,0.8-0.8,1C10.5,67,10,67.1,9.4,67 c-0.6-0.1-1.1-0.3-1.5-0.7c-0.4-0.4-0.5-0.9-0.4-1.5l0,0L8.7,65c-0.1,0.3,0,0.6,0.1,0.7C9,65.8,9.2,65.9,9.5,66 c0.3,0,0.5,0,0.6-0.1C10.3,65.9,10.4,65.7,10.4,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.3,67.4L13,67.3l0.4-5.6l1.3,0.1L14.3,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.3,66.5l2.4,0l0,1l-3.7,0l-0.1-5.6l1.3,0L17.3,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.2,65.8l0.1,0.2l0,0L22.2,65.8l0.9-4.1l1.3-0.1L23,67.2l-1.4,0.1l-2.3-5.4l1.3-0.1L22.2,65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.8,64.1l-1.9,0.3l0.2,1.4l2.3-0.3l0.1,1l-3.6,0.5l-0.8-5.5l3.6-0.5l0.1,1l-2.3,0.3l0.2,1.2l1.9-0.3 L28.8,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.6,63.8l0.4,2.1l-1.3,0.2l-1-5.5l1.9-0.4c0.6-0.1,1.2-0.1,1.6,0.2c0.4,0.2,0.7,0.6,0.8,1.1 c0.1,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.3,0.4-0.6,0.6c0.4,0,0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.5,0.4,0.8l0.1,0.3c0,0.1,0.1,0.3,0.2,0.5 s0.2,0.3,0.3,0.3l0,0.1l-1.3,0.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.5l-0.1-0.3c0-0.3-0.2-0.4-0.3-0.6 c-0.2-0.1-0.4-0.1-0.6-0.1L31.6,63.8z M31.4,62.8l0.6-0.1c0.3,0,0.4-0.1,0.6-0.3c0.1-0.1,0.1-0.3,0.1-0.5c0-0.2-0.1-0.4-0.3-0.5 c-0.2-0.1-0.4-0.1-0.6-0.1l-0.6,0.1L31.4,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.9,62.4L40.9,62.4l0.5-4.1l1.7-0.3l1.1,5.5l-1.3,0.3l-0.7-3.5l0,0L41.7,64l-0.9,0.2L39,60.9l0,0l0.7,3.5 l-1.3,0.3l-1.1-5.5l1.7-0.3L40.9,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.5,60.2l-1.9,0.4l0.3,1.4l2.3-0.4l0.2,1l-3.6,0.7l-1-5.5l3.6-0.7l0.2,1l-2.3,0.4l0.2,1.2l1.9-0.4L48.5,60.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.4,60.1L53.4,60.1l0.8-4l1.7-0.2l0.7,5.5l-1.3,0.2L54.8,58l0,0l-0.7,3.7l-0.9,0.1l-1.7-3.3l0,0L52,62 l-1.3,0.2L50,56.7l1.7-0.2L53.4,60.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.1,61.3l-0.3-5.6l1.8-0.1c0.7,0,1.2,0.1,1.6,0.3c0.4,0.2,0.6,0.6,0.6,1.1c0,0.3,0,0.5-0.2,0.7 c-0.1,0.2-0.3,0.4-0.6,0.5c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.3,0.5,0.3,0.8c0,0.5-0.1,1-0.5,1.3c-0.4,0.3-0.9,0.5-1.5,0.5 L58.1,61.3z M59.3,58l0.5,0c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.2-0.1-0.4-0.1-0.7-0.1l-0.5,0 L59.3,58z M59.3,58.8l0.1,1.4l0.8,0c0.3,0,0.5-0.1,0.6-0.2s0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.6-0.2l0,0 L59.3,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.1,58.9l-2-0.1l-0.1,1.4l2.3,0.1l0,1l-3.6-0.2l0.3-5.6l3.6,0.2l0,1l-2.4-0.1l-0.1,1.2l2,0.1L67.1,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.3,59.5l-0.4,2.1l-1.3-0.2l0.9-5.5l1.9,0.3c0.6,0.1,1.1,0.3,1.4,0.7c0.3,0.4,0.4,0.8,0.4,1.3 c0,0.3-0.2,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.4c0.3,0.2,0.5,0.4,0.6,0.6c0.1,0.2,0.1,0.5,0.1,0.9l-0.1,0.3c0,0.1,0,0.3,0,0.5 c0,0.2,0.1,0.3,0.2,0.4l0,0.1l-1.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.2,0-0.4,0-0.6l0.1-0.3c0-0.3,0-0.5-0.1-0.6 c-0.1-0.2-0.3-0.3-0.6-0.3L70.3,59.5z M70.4,58.5l0.6,0.1c0.3,0,0.5,0,0.6-0.1s0.3-0.3,0.3-0.5c0-0.2,0-0.4-0.1-0.6 c-0.1-0.2-0.3-0.3-0.6-0.3l-0.6-0.1L70.4,58.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverbadge);
export default __webpack_public_path__ + "static/media/Silver badge.0c45c7cc06c82dfd75881ed72c4d99a3.svg";
export { ForwardRef as ReactComponent };